import React from "react";

import { Box } from "../../../primitive";

export const SliderBar = () => {
  return (
    <Box
      left={0}
      top={9}
      width="100%"
      height={2}
      backgroundColor={"outline-default"}
      position="absolute"
    />
  );
};
